<template>
    <div
      class="w-100"
      v-bind:style="ParentCode.toString().length >= 3 ? 'padding: 5px 5px 5px 0px;': ''"
    >
      <table class="table table-bordered text-center table-font-size bg-white m-0">
        <!-- سربرگ جدول -->
        <thead class="text-light" v-bind:style="getColorHead">
          <td 
            colspan="6"
            style="padding: 10px 0 !important;"
            v-bind:style="getHeaderTableFontSize"
          >
            {{getHeaderTable}}
            <span 
              title="تعداد زیر مجموعه" 
              class="mr-2"
              style="font-size: 14px !important"
              v-if="this.ParentCode.toString().length < 3"
            >
              ( <i class="fas fa-share-alt fa-rotate-90"></i>
              {{this.getListChildLastLevel(0).length}} )
            </span>
          </td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="row in getListBaseAcc">
            <tr
              :key="row.NCode"
              v-bind:id="row.NCode"
              :style="getListChildLastLevel(row.NCode).length > 0 ? 'cursor: pointer' : 'cursor: no-drop'"
              class="border-1"
              :class="{ selRow: SearchToListAllShow(row.NCode) == true }"
            >
              <!-- فلش جهت نما -->
              <td
                style="
                  width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                "
                v-on:click="SaveRowSelect(row.NCode, row.SDesc)"
              >
                <!-- منوی مشاهده فرزندان -->
                <a
                  href="#"
                  v-bind:title="'مشاهده حساب های ' + getTitleNewBaseAcc"
                  v-if="getListChildLastLevel(row.NCode).length > 0"
                >
                  <i
                    v-if="SearchToListAllShow(row.NCode) == false"
                    class="far fa-folder fa-1x-half m-1 text-primary"
                  ></i>
                  <i v-else class="far fa-folder-open fa-1x-half m-1 text-primary"></i>
                </a>
                <i v-else class="fas fa-folder-minus fa-1x-half m-1 text-primary"></i>
              </td>
              <!-- کد حساب -->
              <td
                style="
                  width: 70px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
                v-bind:style="ParentCode.toString().length < 7 ? 'font-size: 14px !important; font-weight: bold !important;': ''"
                v-on:click="SaveRowSelect(row.NCode, row.SDesc)"
              >
                {{ row.NCode }}
              </td>
              <!-- عنوان حساب -->
              <td
                style="
                  text-align: right !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding: 10px !important;
                "
                v-bind:style="ParentCode.toString().length < 7 ? 'font-size: 14px !important; font-weight: bold !important;': ''"
                v-on:click="SaveRowSelect(row.NCode, row.SDesc)"
              >
                <div
                  class="d-flex justify-content-between align-items-center w-100"
                >
                  <span>
                    {{ row.SDesc }}
                  </span>
                  <span 
                    class="text-black-50"
                    title="تعداد زیر مجموعه"
                    v-if="row.NCode.toString().length <= 7"
                  >
                    <i class="fas fa-share-alt fa-rotate-90"></i>
                    {{getListChildLastLevel(row.NCode).length}}
                  </span>
                </div>
              </td>
              <!-- نوع حساب -->
              <td>
                {{getNAccTypeName(row.NAccType)}}
              </td>
              <!-- مبلغ بودجه -->
              <td>
                بودجه : {{row.NBudget | numFormat}}
              </td>
              <!-- مدیریت -->
              <td
                style="
                  width: 50px !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                "             
              >
                <!-- منوی ثبت بودجه -->
                <a
                  href="#"
                  title="ثبت بودجه"
                  data-toggle="modal" 
                  v-bind:data-target="'#ModalEditBudget-' + row.NCode"
                  v-on:click="ShowModalEditBudget(row)"
                  >
                  <!-- v-if="getListChildLastLevel(row.NCode).length == 0" -->
                  <i class="fas fa-edit fa-1x-half m-1 text-primary"></i>
                </a>
                <!-- getListChildLastLevel(row.NCode).length > 0 ? 'cursor: pointer' : 'cursor: no-drop' -->
                <!-- منوی تسهیم بندی بودجه -->
                <a
                  href="#"
                  title="تسهیم بندی بودجه"
                  data-toggle="modal" 
                  v-bind:data-target="'#ModalTashimBandi-' + row.NCode"
                  v-on:click="ShowModalTashimBandi(row)"
                  v-if="getListChildLastLevel(row.NCode).length == 0 && row.NAccType == 2"
                  >
                  <i class="fas fa-list-ul fa-rotate-180 fa-1x-half m-1 text-info"></i>
                </a>
                <!-- منوی حذف بودجه -->
                <a
                  href="#"
                  title="حذف رقم بودجه"
                  v-on:click="DeleteBaseAccBudget(row)"
                >
                  <i class="far fa-trash-alt fa-1x-half m-1 text-danger"></i>
                </a>
              </td>
            </tr>
            <!-- نمایش سرفصل های فرزند به صورت فراخوانی بازگشتی -->
            <tr 
              v-if="SearchToListAllShow(row.NCode) == true && getListChildLastLevel(row.NCode).length > 0" 
              :key="'docRows' + row.NCode"
            >
              <td
                style="writing-mode: vertical-rl;
                      font-size: 14px !important;
                      padding: 10px 10px !important;"
              >{{row.SDesc}}</td>
              <td
                colspan="5"
                style="padding: 5px !important; background-color: #f1fdff"
              >
                <ShowTableBaseAcc
                  :key="row.NCode"
                  v-bind:ParentCode = "row.NCode"
                  v-bind:ListTbBaseAccData="getListAllChild(row.NCode)"
                  v-bind:isMultieSelect = "isMultieSelect"
                  v-bind:ListAllShowFilter="ListAllShowFilter"
                ></ShowTableBaseAcc>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <!-- مودال ثبت بودجه برای سرفصل حساب -->
      <EditBudget
        v-if="isShowEditBudgetLocal == true"
        v-on:EditBudget="HideModalEditBudget"
        v-bind:RowBaseAccData="EditTbBaseAcc"
        v-bind:Title1="'ثبت بودجه برای حساب ' + getTitleEditBudget"
        v-bind:EnableNBudget="getListChildLastLevel(EditTbBaseAcc.NCode).length > 0 ? false : true"
      ></EditBudget>

      <!-- مودال تسهیم بندی عملیاتی -->
      <TashimBandi
        v-if="isShowTashimBandiLocal == true"
        v-on:EditBudget="HideModalEditBudget"
        v-bind:RowBaseAccData="EditTbBaseAcc"
        v-bind:Title1="'تسهیم بندی بودجه برای حساب ' + getTitleEditBudget"
        v-bind:EnableNBudget="getListChildLastLevel(EditTbBaseAcc.NCode).length > 0 ? false : true"
      ></TashimBandi>

    </div>
</template>

<script>
import EditBudget from './EditBudget.vue'
import TashimBandi from './TashimBandi.vue'

export default {
  name: 'ShowTableBaseAcc',  // در فراخوانی بازگشتی نام باید هم نام کامپاننت باشد
  props: [
    "ParentCode", // کد حساب والد : صفر یعنی نمایش حساب های کل
    "ListTbBaseAccData", // اطلاعات ورودی به کامپاننت
    "isMultieSelect",  // کنترل وضعیت چند انتخابی
    "ListAllShowFilter"  // اطلاعات تمام سطرهای در حال نمایش
  ],
  components: {
    EditBudget,
    TashimBandi
  },
  data() {
    return {
      LocalBaseAccData: [],  // لیست محلی سرفصل حساب ها
      // اطلاعات سطر در حال انتخاب
      SelectRowData: {
        NCode: 0,
        SDesc: ''
      },
      // اطلاعات تمام سطرهای در حال نمایش
      ListAllShow: [],
      // اطلاعات سرفصل حساب جهت ویرایش اطلاعات
      EditTbBaseAcc: {
        NYear: 1400, // سال
        NCode: "", // کد حساب
        SDesc: "", // شرح حساب
        NAccType: 7, // نوع حساب
        NBudget: "", // رقم بودجه
        NDebitSum: 0, // جمع بدهکار
        NCreditSum: 0, // جمع بستانکار
        NUserCode: 0, // کد کاربر ثبت کننده
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        NPerID: 0, // کد پرسنل
        NRemain1: 0, // باقیمانده 1
        NRemain2: 0, // باقیمانده 2
        NRemain3: 0,
        NRemain4: 0,
        NRemain5: 0,
        NRemain6: 0,
        NRemain7: 0,
        NRemain8: 0,
        NRemain9: 0,
        NRemain10: 0,
        NRemain11: 0,
        NRemain12: 0, // باقیمانده 12
        NBudgetCode: "", // کد بودجه
        NCreditType: 0, // نوع نوع اعتبار
        NUseType: 0, // نوع مصرف منبع
        NUseState: "", // کد ارتباط
      },
      // کد سطر جدید
      NewChildCode: 0,
      // کد نوع سطر جدید
      NewNAccType: 0,
      // کنترل وضعیت نمایش مودال ویرایش اطلاعات
      isShowEditBudgetLocal: false,
      // کنترل وضعیت نمایش مودال تسهیم بندی عملیاتی
      isShowTashimBandiLocal: false,

    };
  },
  computed: {
    // استخراج لیست سرفصل حساب ها
    getListBaseAcc() {
      // بررسی وضعیت جستجو
      if(this.ListAllShowFilter != undefined && this.ListAllShowFilter.length > 0) {
        this.ListAllShow = this.ListAllShowFilter;
      }
      // شروع استخراج لیست سرفصل حساب ها
      let tempNCode = new String(this.ParentCode);
      if (this.ListTbBaseAccData.length > 0) {
        if (tempNCode != 0) {
          if(tempNCode.length >= 7){
            // حساب تفصیلی
            this.LocalBaseAccData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode != tempNCode &&
                item.NCode.toString().length > 7 &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          } else {
            // حساب معین 1 و معین 2
            this.LocalBaseAccData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode.toString().length == (parseInt(tempNCode.length) + 2) &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          }
        } else {
          // حساب کل
          this.LocalBaseAccData = this.ListTbBaseAccData.filter(function (item) {
            return item.NCode.toString().length == 3;
          });
        }
      }
      return this.LocalBaseAccData;
    },
    // ایجاد سایز فونت سربرگ جدول
    getHeaderTableFontSize(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'font-size: 18px !important;';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'font-size: 17px !important;';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'font-size: 16px !important;';
      } else if (this.ParentCode.toString().length >= 7 ){
        strHeader = 'font-size: 15px !important;';
      } else {
        strHeader = 'font-size: 14px !important; font-weight: bold !important;'
      }
      return strHeader;
    },    
    // ایجاد سربرگ جدول
    getHeaderTable(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'حساب های کل';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'حساب های معین 1';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'حساب های معین 2';
      } else if (this.ParentCode.toString().length >= 7 ){
        strHeader = 'حساب های تفصیلی';
      } else {
        strHeader = 'لیست حساب ها'
      }
      return strHeader;
    },
    // دریافت عنوان حساب برای درج جدید
    getTitleNewBaseAcc(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'معین 1';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'معین 2';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'تفصیلی';
      } else {
        strHeader = 'حساب'
      }
      return strHeader;
    },
    // دریافت عنوان حساب برای ویرایش
    getTitleEditBudget(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'کل';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'معین 1';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'معین 2';
      } else {
        strHeader = 'تفصیلی'
      }
      return strHeader;
    },
    // ایجاد رنگ سربرگ
    getColorHead(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'background-color: #9933CC;';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'background-color: #0277bd ';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'background-color: #0288d1';
      } else if (this.ParentCode.toString().length >= 7 ){
        strHeader = 'background-color: #039be5';
      } else {
        strHeader = 'background-color: #ba68c8'
      }
      return strHeader;
    },
  },
  methods: {
    // دریافت نام نوع سرفصل حساب
    getNAccTypeName(NCode){
      return this.$store.getters.getNAccTypeName(NCode)[0].SDesc; 
    },
    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(NCode, SDesc) {
      this.SelectRowData.NCode = NCode;
      this.SelectRowData.SDesc = SDesc;
      if(this.SearchToListAllShow(NCode) == false){
        // افزودن به لیست تمام سطرهای در حال نمای
        this.SaveListAllShow(NCode);
      } else {
        // حذف از لیست تمام سطرهای در حال نمایش
        this.DeleteFromListAllShow(NCode);
      }
    },
    // نگهداری اطلاعات تمام سطرهای در حال نمایش
    SaveListAllShow(NCode){
      if(this.isMultieSelect == true){
        // مقدارد دهی به لیست
        this.ListAllShow.push(NCode);
      } else {
        // خالی کردن لیست
        this.ListAllShow.length = 0;
        // مقدار دهی به لیست
        this.ListAllShow.push(NCode);
      }
    },
    // حذف یک آیتم از لیست تمام سطرهای در حال نمایش
    DeleteFromListAllShow(NCode){
      this.ListAllShow = this.ListAllShow.filter(function(value){
        return value != NCode;
      });
    },
    // جستجو در لیست تمام سطرهای در حال نمایش
    SearchToListAllShow(NCode){
      if(this.ListAllShow.length > 0){
        let index = this.ListAllShow.findIndex(item => item == NCode);
        if(index != -1){
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // تابع نمایش مودال ویرایش اطلاعات سرفصل حساب
    ShowModalEditBudget(row){
      this.EditTbBaseAcc = row;
      this.isShowEditBudgetLocal = true;
    },

    // تابع نمایش مودال تسهیم بندی عملیاتی
    ShowModalTashimBandi(row){
      this.EditTbBaseAcc = row;
      this.isShowTashimBandiLocal = true;
    },
    // استخراج لیست تمام فرزندان
    // جهت پاس دادن لیست تمام فرزندان به کامپاننت فرزند (فراخوانی بازگشتی)
    getListAllChild(ParentCode){
      let tempData = this.ListTbBaseAccData.filter(function (item) {
            return item.NCode.toString().length > ParentCode.length &&
            item.NCode.toString().substring(0, ParentCode.length) == ParentCode
          });
      return tempData;
    },

    // استخراج کد آخرین فرزند جهت درج سطر جدید
    getLastChildCode(NCode){
      let tempCode = 0;
      this.getListChildLastLevel(NCode).forEach(element => {
        if(element.NCode > tempCode){
          tempCode = element.NCode
        }
      });
      if(parseInt(tempCode) > 0){
        // افزایش یک واحدی کد آخرین فرزند
        return (parseInt(tempCode) + 1).toString();
      } else {
        // فرزندی یافت نشد / صدور کد جدید / تفصیلی سه صفر یک
        return (NCode + (NCode.toString().length >= 7 ? '0001' : '01')).toString();
      }
    },

    // استخراج فرزندان سطح بعدی
    // آیا گره انتخابی در سطح بعدی فرزندی دارد ؟ 
    // کنترل حذف - نمایش تعداد فرزندان - استخراج کد آخرین فرزند
    getListChildLastLevel(NCode) {
      let tempNCode = new String(NCode);
      let tempData = [];
      if (this.ListTbBaseAccData.length > 0) {
        if (tempNCode != '0') {
          if(tempNCode.length >= 7){
            // حساب تفصیلی
            tempData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode != tempNCode &&
                item.NCode.toString().length > 7 &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          } else {
            // حساب معین 1 و معین 2
            tempData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode.toString().length == (parseInt(tempNCode.length) + 2) &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          }
        } else {
          // حساب کل
          tempData = this.ListTbBaseAccData.filter(function (item) {
            return item.NCode.toString().length == 3;
          });
        }
      }
      return tempData;
    },

    // رویداد بسته شدن مودال ویرایش اطلاعات سرفصل حساب
    HideModalEditBudget(){
      // مخفی کردن مودال ویرایش اطلاعات سرفصل حساب
      this.isShowEditBudgetLocal = false;
    },

    // تابع حذف رقم بودجه از سرفصل حساب
    DeleteBaseAccBudget(row){
      swal({
        title: "تقاضای حذف رقم بودجه",
        text: "این کار باعث حذف رقم بودجه سرفصل حساب انتخابی و تمام فرزندان آن خواهد شد ! آیا مایلید رقم بودجه از سرفصل حساب ( " + row.NCode + " - " + row.SDesc + " ) حذف شود ؟",
        icon: "warning", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله رقم بودجه از سرفصل حساب حذف شود",
        },
      }).then(async (value) => {
        if (value) {
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: "حذف رقم بودجه از سرفصل حساب",
          });
          // دریافت توکن احراز هویت
          let token = await this.$store.getters.getUserData.token;
          // ارسال تقاضای حذف رقم بودجه از سرفصل حساب به سرور
          await this.$store.dispatch("DeleteBaseAccBudgetToServer", {
            DeleteBaseAcc: row,
            token: token,
          });
          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/Budgeting/Components/ShowTableBaseAcc.vue